import Client from './client';
import EventStream from './eventstream';

export const API = new Client();
export const SSE = new EventStream();
export const ServerEvents = SSE;



//////////////////
// WEBPACK FOOTER
// ./src/global.js
// module id = 20
// module chunks = 0